
import React from "react";

export default function SEO({ keyword, description }) {
  return (
   <>
      <meta name="description" content={description || ''} />
      <meta name="keywords" content={keyword || ''} />
      <meta name="robots" content="index, follow"/>
      

   </>
    
  );
}
